import { client } from '../utils'
import { people as endpoints } from '../api_urls'

export const updatePageNum = async (payload, dispatch) => {
  try {
    let resp = await client.post(`${endpoints.paginatePeople()}`, payload)
    switch (payload.table) {
      case 'courseMember':
        dispatch({ type: 'UPDATE_COURSE_MEMBER_PAGE', payload: payload.page })
        dispatch({ type: 'UPDATE_PEOPLE_DATA', payload: resp.data.peopleData })
        dispatch({
          type: 'UPDATE_ACTIVE_COUNT',
          payload: resp.data.peopleCount,
        })
        break
      case 'archivedMember':
        dispatch({ type: 'UPDATE_ARCHIVED_MEMBER_PAGE', payload: payload.page })
        dispatch({
          type: 'UPDATE_ARCHIVED_MEMBERS',
          payload: resp.data.archivedData,
        })
        dispatch({
          type: 'UPDATE_ARCHIVED_COUNT',
          payload: resp.data.archivedCount,
        })
        break
      case 'section':
        dispatch({ type: 'UPDATE_SECTION_PAGE', payload: payload.page })
        dispatch({ type: 'UPDATE_SECTIONS', payload: resp.data.sectionData })
        dispatch({
          type: 'UPDATE_SECTION_COUNT',
          payload: resp.data.sectionCount,
        })
        break
      default:
        return null
    }
  } catch (err) {
    console.error(`Error getting paginated data for ${payload.table}`, err)
    // The pager that asked for this page announces the failure.
    throw err
  }
}

export const newSection = async (name, offset, dispatch) => {
  let url = endpoints.newSection()
  try {
    let response = await client.post(url, {
      section_title: name,
      time_offset: offset,
    })
    dispatch({ type: 'UPDATE_SECTION_PAGE', payload: 1 })
    dispatch({ type: 'UPDATE_SECTIONS', payload: response.data.sectionData })
    dispatch({
      type: 'UPDATE_SECTION_COUNT',
      payload: response.data.sectionCount,
    })
    dispatch({
      type: 'UPDATE_ALL_SECTIONS',
      payload: response.data.allSectionData,
    })
    return response
  } catch (err) {
    console.error(`Error fetching ${url}`, err)
    return err.response ?? { status: 0, data: { error: 'A network error occurred. Please try again.' } }
  }
}

export const addPeople = async (data, dispatch) => {
  let url = endpoints.addPeople()
  try {
    let resp = await client.post(url, data)
    if (resp.data.peopleData.length >= 0) {
      dispatch({ type: 'UPDATE_PEOPLE_DATA', payload: resp.data.peopleData })
    } else {
      throw new Error('Problem with active people objects.')
    }
    if (resp.data.peopleCount >= 0) {
      dispatch({ type: 'UPDATE_ACTIVE_COUNT', payload: resp.data.peopleCount })
    } else {
      throw new Error('Problem with active people count.')
    }
    if (resp.data.archiveData.length >= 0) {
      dispatch({
        type: 'UPDATE_ARCHIVED_MEMBERS',
        payload: resp.data.archiveData,
      })
    } else {
      throw new Error('Problem with archived people objects.')
    }
    if (resp.data.archivedCount >= 0) {
      dispatch({
        type: 'UPDATE_ARCHIVED_COUNT',
        payload: resp.data.archivedCount,
      })
    } else {
      throw new Error('Problem with archived people count.')
    }
    dispatch({
      type: 'UPDATE_COURSE_MEMBER_PAGE',
      payload: resp.data.courseMemPage,
    })
    dispatch({
      type: 'UPDATE_ARCHIVED_MEMBER_PAGE',
      payload: resp.data.archivedMemPage,
    })
    return resp
  } catch (err) {
    console.error(`Error: ${err}`)
    throw err
  }
}

export const tempAccess = async (data, dispatch) => {
  let url = endpoints.tempAccess()
  try {
    let resp = await client.post(url, data)
    dispatch({ type: 'UPDATE_PEOPLE_DATA', payload: resp.data.peopleData })
    dispatch({ type: 'UPDATE_ACTIVE_COUNT', payload: resp.data.peopleCount })
    dispatch({
      type: 'UPDATE_ARCHIVED_MEMBERS',
      payload: resp.data.archiveData,
    })
    dispatch({
      type: 'UPDATE_ARCHIVED_COUNT',
      payload: resp.data.archivedCount,
    })
    dispatch({
      type: 'UPDATE_COURSE_MEMBER_PAGE',
      payload: resp.data.courseMemPage,
    })
    dispatch({
      type: 'UPDATE_ARCHIVED_MEMBER_PAGE',
      payload: resp.data.archivedMemPage,
    })
    return resp
  } catch (err) {
    console.error(`Error fetching ${url}.`, err)
    throw err
  }
}

export const saveNewSectionName = async (payload, dispatch) => {
  try {
    let resp = await client.post(endpoints.editSectionName(), payload)
    dispatch({ type: 'UPDATE_SECTIONS', payload: resp.data.sectionData })
    dispatch({ type: 'UPDATE_ALL_SECTIONS', payload: resp.data.allSectionData })
    dispatch({ type: 'UPDATE_PEOPLE_DATA', payload: resp.data.peopleData })
    dispatch({ type: 'UPDATE_ACTIVE_COUNT', payload: resp.data.peopleCount })
    dispatch({
      type: 'UPDATE_COURSE_MEMBER_PAGE',
      payload: resp.data.courseMemPage,
    })
    dispatch({
      type: 'UPDATE_ARCHIVED_MEMBER_PAGE',
      payload: resp.data.archivedMemPage,
    })
    dispatch({
      type: 'UPDATE_ARCHIVED_MEMBERS',
      payload: resp.data.archiveData,
    })
    dispatch({
      type: 'UPDATE_ARCHIVED_COUNT',
      payload: resp.data.archivedCount,
    })
    return resp
  } catch (err) {
    return err.response ?? { status: 0, data: { error: 'A network error occurred. Please try again.' } }
  }
}

export const removeSection = async (payload, dispatch) => {
  let resp = await client.post(endpoints.removeSection(), payload)
  dispatch({ type: 'UPDATE_SECTIONS', payload: resp.data.sectionData })
  dispatch({ type: 'UPDATE_ALL_SECTIONS', payload: resp.data.allSectionData })
  dispatch({ type: 'UPDATE_PEOPLE_DATA', payload: resp.data.peopleData })
  dispatch({ type: 'UPDATE_ACTIVE_COUNT', payload: resp.data.peopleCount })
  dispatch({ type: 'UPDATE_ARCHIVED_MEMBERS', payload: resp.data.archiveData })
  dispatch({ type: 'UPDATE_ARCHIVED_COUNT', payload: resp.data.archivedCount })
  dispatch({
    type: 'UPDATE_COURSE_MEMBER_PAGE',
    payload: resp.data.courseMemPage,
  })
  dispatch({
    type: 'UPDATE_ARCHIVED_MEMBER_PAGE',
    payload: resp.data.archivedMemPage,
  })
  dispatch({ type: 'UPDATE_SECTION_PAGE', payload: 1 })
  dispatch({ type: 'UPDATE_SECTION_COUNT', payload: resp.data.sectionCount })
  return resp
}

export const setExpirationDate = async (payload, dispatch) => {
  try {
    let resp = await client.post(endpoints.setExpirationDate(), payload)
    dispatch({ type: 'UPDATE_SECTIONS', payload: resp.data.sectionData })
    dispatch({ type: 'UPDATE_ALL_SECTIONS', payload: resp.data.allSectionData })
    return resp
  } catch (err) {
    return err.response ?? { status: 0, data: { error: 'A network error occurred. Please try again.' } }
  }
}

export const archiveMembers = async (memberList, dispatch) => {
  let url = endpoints.archiveMembers()
  try {
    let resp = await client.post(url, memberList)
    dispatch({ type: 'UPDATE_PEOPLE_DATA', payload: resp.data.peopleData })
    dispatch({ type: 'UPDATE_ACTIVE_COUNT', payload: resp.data.peopleCount })
    dispatch({
      type: 'UPDATE_ARCHIVED_MEMBERS',
      payload: resp.data.archiveData,
    })
    dispatch({
      type: 'UPDATE_ARCHIVED_COUNT',
      payload: resp.data.archivedCount,
    })
    dispatch({ type: 'UPDATE_TO_BE_ARCHIVED_MEMBERS', payload: [] })
    dispatch({
      type: 'UPDATE_ARCHIVED_MEMBER_PAGE',
      payload: resp.data.archivedMemPage,
    })
    dispatch({
      type: 'UPDATE_COURSE_MEMBER_PAGE',
      payload: resp.data.courseMemPage,
    })
    return resp
  } catch (err) {
    console.error(err)
    throw err
  }
}

export const unarchiveCourseMember = async (payload, dispatch) => {
  let resp = await client.post(endpoints.unarchiveCourseMember(), payload)
  dispatch({ type: 'UPDATE_PEOPLE_DATA', payload: resp.data.peopleData })
  dispatch({ type: 'UPDATE_ACTIVE_COUNT', payload: resp.data.peopleCount })
  dispatch({
    type: 'UPDATE_ARCHIVED_MEMBERS',
    payload: resp.data.archiveData,
  })
  dispatch({
    type: 'UPDATE_ARCHIVED_COUNT',
    payload: resp.data.archivedCount,
  })
  dispatch({
    type: 'UPDATE_COURSE_MEMBER_PAGE',
    payload: resp.data.courseMemPage,
  })
  dispatch({
    type: 'UPDATE_ARCHIVED_MEMBER_PAGE',
    payload: resp.data.archivedMemPage,
  })
  return resp
}

export const removeCourseMember = async (payload, dispatch) => {
  try {
    let resp = await client.post(endpoints.removeCourseMember(), payload)
    dispatch({ type: 'UPDATE_PEOPLE_DATA', payload: resp.data.peopleData })
    dispatch({ type: 'UPDATE_ACTIVE_COUNT', payload: resp.data.peopleCount })
    dispatch({
      type: 'UPDATE_ARCHIVED_MEMBERS',
      payload: resp.data.archiveData,
    })
    dispatch({
      type: 'UPDATE_ARCHIVED_MEMBER_PAGE',
      payload: resp.data.archivedMemPage,
    })
    dispatch({
      type: 'UPDATE_ARCHIVED_COUNT',
      payload: resp.data.archivedCount,
    })
    dispatch({
      type: 'UPDATE_COURSE_MEMBER_PAGE',
      payload: resp.data.courseMemPage,
    })
    return resp
  } catch (err) {
    return {
      status: err.response?.status,
      message: err.response?.data?.error,
    }
  }
}

export const fixLmsId = async payload => {
  try {
    let resp = await client.post(endpoints.fixLmsId(), payload)
    return resp
  } catch (err) {
    return {
      status: err.response?.status,
      message: err.response?.data?.error,
    }
  }
}

export const uploadGradesToLms = async payload => {
  try {
    let resp = await client.post(endpoints.uploadGradesToLms(), payload)
    return resp
  } catch (err) {
    return {
      status: err.response?.status,
      message: err.response?.data?.error,
    }
  }
}

export const forceReadingAnalytics = async payload => {
  try {
    let resp = await client.post(endpoints.forceReadingAnalytics(), payload)
    return resp
  } catch (err) {
    return {
      status: err.response?.status,
      message: err.response?.data?.error,
    }
  }
}

export const forceVideoAnalytics = async payload => {
  try {
    let resp = await client.post(endpoints.forceVideoAnalytics(), payload)
    return resp
  } catch (err) {
    return {
      status: err.response?.status,
      message: err.response?.data?.error,
    }
  }
}

export const filterPeople = async (payload, dispatch) => {
  let url = endpoints.getTableData()
  try {
    let resp = await client.post(url, payload)
    dispatch({ type: 'UPDATE_PEOPLE_DATA', payload: resp.data.active })
    dispatch({ type: 'UPDATE_ARCHIVED_MEMBERS', payload: resp.data.archived })
    dispatch({ type: 'UPDATE_ACTIVE_COUNT', payload: resp.data.peopleCount })
    dispatch({
      type: 'UPDATE_ARCHIVED_COUNT',
      payload: resp.data.archivedCount,
    })
    dispatch({
      type: 'UPDATE_COURSE_MEMBER_PAGE',
      payload: resp.data.courseMemPage,
    })
    dispatch({
      type: 'UPDATE_ARCHIVED_MEMBER_PAGE',
      payload: resp.data.archivedMemPage,
    })
    return resp
  } catch (err) {
    console.error(`Error fetching ${url}`, err)
    throw err
  }
}

export const archiveSection = async (payload, dispatch) => {
  let resp = await client.post(endpoints.archiveSection(), payload)
  dispatch({ type: 'UPDATE_PEOPLE_DATA', payload: resp.data.peopleData })
  dispatch({ type: 'UPDATE_ACTIVE_COUNT', payload: resp.data.peopleCount })
  dispatch({
    type: 'UPDATE_ARCHIVED_MEMBERS',
    payload: resp.data.archiveData,
  })
  dispatch({
    type: 'UPDATE_ARCHIVED_COUNT',
    payload: resp.data.archivedCount,
  })
  dispatch({
    type: 'UPDATE_COURSE_MEMBER_PAGE',
    payload: resp.data.courseMemPage,
  })
  dispatch({
    type: 'UPDATE_ARCHIVED_MEMBER_PAGE',
    payload: resp.data.archivedMemPage,
  })
  return resp
}

export const bulkFixLmsIds = async payload => {
  try {
    let resp = await client.post(endpoints.bulkUpdateLmsIds(), payload)
    return resp
  } catch (err) {
    return {
      status: err.response?.status,
      message: err.response?.data?.error,
    }
  }
}

export const bulkUploadGrades = async payload => {
  try {
    let resp = await client.post(endpoints.bulkUploadGrades(), payload)
    return resp
  } catch (err) {
    return {
      status: err.response?.status,
      message: err.response?.data?.error,
    }
  }
}
